// 👇 Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// 👇 Axios Imports
import axios from 'axios'

import { urlTimeSheetService } from '@src/endpoints'

import { getUriParams } from '@src/utility/Utils'

export const getAllData = createAsyncThunk('outsourcedTimeSheets/getAllData', async () => {
  const response = await axios.get(`${urlTimeSheetService}/GetAllTimeSheetsCount?isTempWorker=true`)
  return {
    data: response.data,
    loadedAll: true
  }
})

export const getData = createAsyncThunk('outsourcedTimeSheets/getData', async params => {
  const uri = getUriParams(params)
  const TimeSheetFilter = {
    userId: params.userId,
    IsDriver: false,
    fullName: params.fullName,
    punchType: params.punchType,
    startDateTime: params.startDateTime,
    endDateTime: params.endDateTime,
    deviceName: params.deviceName,
    siteLocation: params.siteLocation,
    status: params.status,
    isSoftDeleted: params.isSoftDeleted,
    reportForgotClockOut: params.reportForgotClockOut ?? null,
    isTempWorker: true,
    companyId: params.companyId ?? null
  }
  const response = await axios.post(`${urlTimeSheetService}/GetAllTimeSheets?${uri}`, TimeSheetFilter)
  return {
    params,
    data: response.data,
    totalPages: response.data.length > 0 ? response.data[0].totalCount : 0,
    loaded: true
  }
})

export const getTimeSheetsUser = createAsyncThunk('outsourcedTimeSheets/getTimeSheetsUser', async () => {
  const response = await axios.get(`${urlTimeSheetService}/GetTimeSheetsUser?isTempWorker=true`)
  const allTimeSheetUser = [{ value: '', label: 'Select...' }, ...response.data]
  return allTimeSheetUser
})

export const outsourcedTimeSheetsSlice = createSlice({
  name: 'outsourcedTimeSheets',
  initialState: {
    loaded: false,
    loadedAll: false,
    data: [],
    total: 1,
    params: {},
    allData: {},
    allTimeSheetUser: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.pending, (state) => {
        state.loadedAll = false
      })
      .addCase(getAllData.fulfilled, (state, action) => {
        state.loadedAll = action.payload.loadedAll
        state.allData = action.payload.data
      })
      .addCase(getData.pending, (state) => {
        state.loaded = false
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.loaded = action.payload.loaded
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getTimeSheetsUser.fulfilled, (state, action) => {
        state.allTimeSheetUser = action.payload
      })
  }
})

export default outsourcedTimeSheetsSlice.reducer
